<template>
  <div>
    <!-- v-if="dataProfile.length != 0" -->
    <a-card :bordered="true">
      <a-row>
        <a-col class="text-center" :span="4" :offset="4">
          <a-avatar :size="120" shape="square" :src="dataProfile[0]['file_img']" />
          <a-form-item class="mt-10 mb-10" label="" help="accept : .png / .jpg / .jpeg">
            <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :multiple="false"
              v-model="fileUpload">
              <a-button block> Select File </a-button>
            </a-upload>
          </a-form-item>
        </a-col>

        <a-col :span="6" style="text-align: left; margin-top: 20px">
          <a-button type="primary" @click="handleFile">
            <a-icon type="upload" /> upload new photo
          </a-button>
        </a-col>
      </a-row>
      <a-row class="mt-20 mb-10" :gutter="[16, 16]">
        <a-col :span="6">
          <p class="text-right mt-5 mb-0 font-bold">Name-Surname :</p>
        </a-col>
        <a-col :span="12">
          <p class="mt-5 mb-5 font-bold" v-if="dataProfile[0].name_detail.length != 0">
            {{
              `${checkBlank(
                dataProfile[0].name_detail[dataProfile[0].name_detail.length - 1].eng_first_name
              )} ${checkBlank(
                dataProfile[0].name_detail[dataProfile[0].name_detail.length - 1].eng_middle_name
              )} ${checkBlank(dataProfile[0].name_detail[dataProfile[0].name_detail.length - 1].eng_last_name)}`
            }}
          </p>
        </a-col>
      </a-row>

      <a-row class="mt-20 mb-10" :gutter="[16, 16]">
        <a-col :span="6">
          <p class="text-right mt-5 mb-0 font-bold">ชื่อ-นามสกุล :</p>
        </a-col>
        <a-col :span="12">
          <p class="mt-5 mb-5 font-bold" v-if="dataProfile[0].name_detail.length != 0">
            {{
              `${checkBlank(
                dataProfile[0].name_detail[dataProfile[0].name_detail.length - 1].thai_first_name
              )} ${checkBlank(
                dataProfile[0].name_detail[dataProfile[0].name_detail.length - 1].thai_middle_name
              )} ${checkBlank(dataProfile[0].name_detail[dataProfile[0].name_detail.length - 1].thai_last_name)}`
            }}
          </p>
        </a-col>
      </a-row>

      <a-row class="mt-20 mb-10" :gutter="[16, 16]">
        <a-col :span="6">
          <p class="text-right mt-5 mb-0 font-bold">MUICAA Member :</p>
        </a-col>
        <a-col :span="12">
          <p class="mt-5 mb-5 font-bold">
            {{ `${checkBlank(dataProfile[0].membership_id)}` }}
          </p>
        </a-col>
      </a-row>

      <a-row class="mt-20 mb-10" :gutter="[16, 16]">
        <a-col :span="6">
          <p class="text-right mt-5 mb-0 font-bold">Student ID :</p>
        </a-col>
        <a-col :span="12">
          <p class="mt-5 mb-5 font-bold">
            {{ `${checkBlank(dataProfile[0].student_id)}` }}
          </p>
        </a-col>
      </a-row>

      <a-row class="mt-20 mb-10" :gutter="[16, 16]">
        <a-col :span="6">
          <p class="text-right mt-5 mb-0 font-bold">Major :</p>
        </a-col>
        <a-col :span="12">
          <p v-if="!['', null].includes(dataProfile[0].major_detail)" class="mt-5 mb-5 font-bold">
            {{ `${dataProfile[0].major_detail.name_eng} ` }}​({{ `${dataProfile[0].major_detail.name_thai}` }})
          </p>
        </a-col>
      </a-row>

      <a-row class="mt-20 mb-10" :gutter="[16, 16]">
        <a-col :span="6">
          <p class="text-right mt-5 mb-0 font-bold">Graduate Year :</p>
        </a-col>
        <a-col :span="12">
          <p v-if="!['', null].includes(dataProfile[0].graduate_year)" class="mt-5 mb-5 font-bold">
            {{ `${dataProfile[0].graduate_year}` }}
            <!-- {{ `${moment(dataProfile[0].graduate_date).format("YYYY")}` }} -->
          </p>
        </a-col>
      </a-row>

      <a-row class="mt-20 mb-10" :gutter="[16, 16]">
        <a-col :span="6">
          <p class="text-right mt-5 mb-0 font-bold">Graduate Date :</p>
        </a-col>
        <a-col :span="12">
          <p v-if="!['', null].includes(dataProfile[0].graduate_date)" class="mt-5 mb-5 font-bold">
            {{
              `${moment(dataProfile[0].graduate_date).format(
                "DD / MMMM / YYYY"
              )}`
            }}
          </p>
        </a-col>
      </a-row>

      <!-- <a-row class="mt-20 mb-10" :gutter="[16, 16]">
          <a-col :span="6">
            <p class="text-right mt-5 mb-0 font-bold">Graduate Status :</p>
          </a-col>
          <a-col :span="12">
            <p
              v-if="
                !['', null].includes(dataProfile[0].graduate_status_detetail)
              "
              class="mt-5 mb-5 font-bold"
            >
              {{ `${dataProfile[0].graduate_status_detetail.name_eng}` }}
            </p>
          </a-col>
        </a-row> -->

      <!-- <a-row class="mt-20 mb-10" :gutter="[16, 16]">
          <a-col :span="6">
            <p class="text-right mt-10 mb-0 font-bold">Contact :</p>
          </a-col>
          <a-col :span="12">
            <a-list
              item-layout="horizontal"
              :data-source="dataProfile[0].contact_detail"
            >
              <a-list-item
                v-if="index == dataProfile[0].contact_detail.length - 1"
                slot="renderItem"
                slot-scope="item, index"
              >
                <a-list-item-meta>
                  <p slot="title" class="mt-0 mb-5">
                    Tel : {{ item.phone_number }}
                  </p>
                  <div slot="description" class="mt-0 mb-0">
                    <p class="text-dark mt-0 mb-0">Email : {{ item.email }}</p>
                    <p class="text-dark mt-0 mb-0">
                      Address : {{ item.address }}
                    </p>
                    <small class="mt-0 mb-0">
                      Create at :
                      {{ moment(item.created_at).format("DD-MMMM-YYYY") }}
                    </small>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-col>
        </a-row> -->

      <a-row class="mt-20 mb-10" :gutter="[16, 16]">
        <a-col :span="6">
          <p class="text-right mt-10 mb-0 font-bold">Work :</p>
        </a-col>
        <a-col :span="12">
          <a-list item-layout="horizontal" :data-source="dataProfile[0].work_detail">
            <a-list-item v-if="index == dataProfile[0].work_detail.length - 1" slot="renderItem"
              slot-scope="item, index">
              <a-list-item-meta>
                <p slot="title" class="mt-0 mb-5">
                  {{ item.position_name }}
                  <!-- <span class="mr-5" v-if="item.family_owned_business === 'yes'"><a-tag class="" color="green">
                      Family owned business : Yes
                    </a-tag></span> -->
                </p>
                <div slot="description" class="mt-0 mb-0">
                  <p class="text-dark mt-0 mb-0">
                    Company : {{ item.company_name }}
                  </p>
                  <!-- <p class="text-dark mt-0 mb-0">
                    Work :
                    {{ }} -
                    {{ moment(item.end_work).format("DD-MMMM-YYYY") }}
                  </p>
                  <small class="mt-0 mb-0">
                    Create at :
                    {{ moment(item.created_at).format("DD-MMMM-YYYY") }}
                  </small> -->
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
const form = {
  file_img: "",
};
export default {
  props: {
    dataProfile: {
      type: Array,
      default: () => [],
    },
  },
  mounted() { },
  methods: {
    checkBlank(val) {
      return !["", null, "null"].includes(val) ? val : "";
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.fileUpload = file;
      this.fileList = [...this.fileList, file];
      return false;
    },
    async handleFile() {
      const sendData = new FormData();
      sendData.append("file_img", this.fileUpload);
      try {
        const response = await this.$http.patch(
          `/student_affair/alumni-profile/${this.dataProfile[0].id}/`,
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 200) {
          this.fileList = [];
          this.$emit("updateData", { data: response.data });
          this.fileUpload = "";
        } else {
          throw { response };
        }
      } catch (error) {
        this.$emit("errorNotification", {
          errorMsg: error.response.status,
          urlPath: `/student_affair/alumni-profile/${this.dataProfile[0].id}/`,
        });
      }
    },
  },
  data() {
    return {
      // file upload
      fileList: [],
      uploading: false,
      fileUpload: null,
    };
  },
};
</script>